"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmlsHeader = void 0;
/* eslint-disable sonarjs/cognitive-complexity */
const react_1 = __importStar(require("react"));
const reactstrap_1 = require("reactstrap");
const className_1 = require("../../utils/className");
exports.SmlsHeader = ({ id, steps, active, onlyProgressBar = false, logo, shadow = true, progress, onBrandClick = () => undefined, onNavClick = () => undefined, }) => {
    const [isOpen, setIsOpen] = react_1.useState(false);
    const [isDesktop, setIsDesktop] = react_1.useState(false);
    const verifyIfIsDesktop = react_1.useCallback((width, height) => {
        if (width < 768)
            setIsDesktop(false);
        else
            setIsDesktop(true);
    }, []);
    react_1.useEffect(() => {
        verifyIfIsDesktop(window.innerWidth, window.innerHeight);
        window.addEventListener('resize', () => {
            verifyIfIsDesktop(window.innerWidth, window.innerHeight);
        });
    }, [verifyIfIsDesktop]);
    const getProgress = () => {
        if (!progress && progress !== 0)
            return ((active + 1) / steps.length) * 100;
        return progress;
    };
    return (react_1.default.createElement("div", { id: id, className: "navbar-container" },
        react_1.default.createElement(reactstrap_1.Navbar, { className: `navbar-expand-lg ${shadow ? 'shadow' : ''}` },
            logo && isDesktop && (react_1.default.createElement(reactstrap_1.NavbarBrand, { onClick: onBrandClick }, logo)),
            react_1.default.createElement(reactstrap_1.Dropdown, { isOpen: isOpen, toggle: () => setIsOpen((prevState) => !prevState) },
                isDesktop ? (react_1.default.createElement(reactstrap_1.DropdownToggle, null, steps[active])) : (react_1.default.createElement(reactstrap_1.DropdownToggle, { onClick: () => onNavClick(active) }, steps[active])),
                isDesktop && (react_1.default.createElement("div", { className: "dropdown-menu" }, steps.map((step, i) => (react_1.default.createElement(reactstrap_1.DropdownItem, { key: step, onClick: () => onNavClick(i) }, step)))))),
            react_1.default.createElement("div", { className: "steps" },
                react_1.default.createElement("ul", { className: "navbar-nav" }, steps.length > 0 &&
                    steps.map((step, i) => (react_1.default.createElement(reactstrap_1.NavItem, { key: step, active: i <= active, className: i === active ? 'selected' : '', onClick: () => onNavClick(i) },
                        react_1.default.createElement(reactstrap_1.NavLink, { href: "#" }, step))))),
                steps.length > 1 && (react_1.default.createElement("div", { className: className_1.mapToCssModules([
                        'progress',
                        onlyProgressBar ? 'only-progress' : '',
                    ]) },
                    react_1.default.createElement(reactstrap_1.Progress, { bar: true, value: getProgress() })))),
            !isDesktop && (react_1.default.createElement("a", { href: "#", onClick: onBrandClick },
                react_1.default.createElement("i", { className: "material-icons notranslate" }, "\uE5CD")))),
        steps.length > 1 && (react_1.default.createElement("div", { className: className_1.mapToCssModules([
                'progress',
                onlyProgressBar ? 'only-progress' : '',
            ]), style: { display: onlyProgressBar ? 'flex' : '' } },
            react_1.default.createElement(reactstrap_1.Progress, { bar: true, value: getProgress() })))));
};
//# sourceMappingURL=index.js.map